import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { BlockUiService } from './block-ui-service';

export const httpBlockInterceptor: HttpInterceptorFn = (req, next) => {
  const blockUiService = inject(BlockUiService);

  // Start blocking
  blockUiService.start();

  return next(req).pipe(
    // Stop blocking when the request is complete (success or error)
    finalize(() => {
      blockUiService.stop();
    }),
  );
};
